
const fn = async () => {
  return 'createFn'
}

export default fn
